import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss'],
})
export class AboutComponent implements OnInit {
  memberAmt;
  subscriptions: Subscription = new Subscription();

  constructor(private userService: UserService, private analyticsService: AnalyticsService) {}

  ngOnInit() {
    this.analyticsService.event('about_view');
    this.subscriptions.add(
      this.userService.getMembers().subscribe((m) => {
        if (m) {
          this.memberAmt = m.length;
        }
      })
    )
  }
}
